import { Component, Input } from '@angular/core';
import { SRouterLinkWithHrefDirective, TranslateDirective } from '@speedy/core';

@Component({
  standalone: true,
  selector: 'app-speedy-link-button',
  templateUrl: './speedy-link-button.component.html',
  styleUrls: ['./speedy-link-button.component.scss'],
  imports: [SRouterLinkWithHrefDirective, TranslateDirective],
})
export class SpeedyLinkButtonComponent {
  /** Flag to set the text */
  @Input() text = '';

  /** Flag to set link type */
  @Input() type: 'outline' | 'primary' = 'primary';

  /** Flag to set url */
  @Input() url: string[] | string = '';
}
